
import axios from 'axios';
import { useState, useRef, useEffect, useContext } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import FaceIcon from '@mui/icons-material/Face';
import Face4Icon from '@mui/icons-material/Face4';

import { RadioButton } from 'primereact/radiobutton';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { TabView, TabPanel } from 'primereact/tabview';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Chip } from 'primereact/chip';
import { InputText } from 'primereact/inputtext';
        
import { addManagerList2MemberList, addAssignList2MemberList, addNumber2MemberList, getChip, getFace, updateManagerSupervisorList, sortMemberList, isSelected, getServiceListItem } from '../Utilities/common';
import { DEBUG, API_BASE_URL_UAT, API_BASE_URL, BOOK_LIST } from '../Utilities/constant';

import mui from '../Imports/muiImports';
import reducer from '../Imports/reducerImports';
import component from '../Imports/componentImports';
import { useShared } from '../Utilities/allContext1';
import { setSupervisorList, setManagerList } from '../Redux/allReducer';

export default function Assign({serviceListItem, displayMode, modify}){

  const { setMemberList } = reducer;
  const { MemberTable, DataGrid1 } = component;  
  const { updateDBSupervisorList, updateDBManagerList, getAssignList, updateAssignList, getServiceList, getMemberList } = useShared();

  const dispatch = useDispatch(); // dispatch(
  const memberList = useSelector((state) => state.all.memberList);
  const serviceList = useSelector((state) => state.all.serviceList);
  const assignList = useSelector((state) => state.all.assignList);
  const managerList = useSelector((state) => state.all.managerList);
  const supervisorList = useSelector((state) => state.all.supervisorList);
  const username = useSelector((state) => state.signIn.username);

  const [selectedMemberList1, setSelectedMemberList1] = useState([]);
  const [selectedMemberList2, setSelectedMemberList2] = useState([]);
  const [selectedMemberList3, setSelectedMemberList3] = useState([]);
  const [rowsPerPage1, setRowsPerPage1] = useState(10);
  const [rowsPerPage2, setRowsPerPage2] = useState(10);
  const [rowsPerPage3, setRowsPerPage3] = useState(10);
  const [first1, setFirst1] = useState(0);
  const [first2, setFirst2] = useState(0);
  const [first3, setFirst3] = useState(0);
  const [visible1, setVisible1] = useState(false);
  const [visible2, setVisible2] = useState(false);
  const [visible3, setVisible3] = useState(false);

  const [header, setHeader] = useState(null);
  const [managerServiceNames, setManagerServiceNames] = useState(null);
  const [serviceNames, setAssignServiceNames] = useState(null);
  const [serviceMember, setServiceMember] = useState(null);
  const [visible4, setVisible4] = useState(false);
  const [globalFilter, setGlobalFilter] = useState('');

  const handleChipClick = (member) => {
    
    setHeader(DEBUG ? `${member.sort}:${member.chineseName} ID${member.id}` : `${member.sort}:${member.chineseName}`);
    setServiceMember(member);

    //const managerServiceIds = managerList.filter(manager => manager.memberId === member.id).map(manager => manager.serviceId);
    const managerServiceNames = member.managerServiceIdList.map(serviceId => {
        const service = serviceList.find(service => service.id === serviceId);
        return service.name; // Return name or null
    });
    setManagerServiceNames(managerServiceNames);

    //const serviceIds = assignList.filter(assign => assign.memberId === member.id).map(assign => assign.serviceId);
    const assignServiceNames = member.assignServiceIdList.map(serviceId => {
        const service = serviceList.find(service => service.id === serviceId);
        return service.name; // Return name or null
    });
    setAssignServiceNames(assignServiceNames);

    setVisible4(true);

  }

  // const getChip = (member) => {
  //   return <span> <Chip icon={getFace(member.gender)} label={` ${member.sort}:${member.chineseName} ID${member.id}`} style={{ margin: '5px' }} onClick={() => handleChipClick(member)}/> </span>
  // }

  const updateRowsPerPage1 = (e) => {
    setRowsPerPage1(e.rows);
    setFirst1(e.first);
  }

  const updateRowsPerPage2 = (e) => {
    setRowsPerPage2(e.rows);
    setFirst2(e.first);
  }

  const updateRowsPerPage3 = (e) => {
    setRowsPerPage3(e.rows);
    setFirst3(e.first);
  }

  const syncSelectedMemberList2 = async (list3) => {
    const list2 = selectedMemberList2;
    const filteredList2 = list2.filter(item2 => list3.some(item3 => item3.id === item2.id));
    updateSelectedMemberList2(filteredList2);

  }

  const updateSelectedMemberList1 = async (list) => {
    sortMemberList(list);
    setSelectedMemberList1(list);
    updateDBManagerList(serviceListItem.id, list);
    const updatedManagerList = updateManagerSupervisorList(username, managerList, serviceListItem.id, list);
    dispatch(setManagerList(updatedManagerList));
  }

  const updateSelectedMemberList2 = async (list) => {
    sortMemberList(list);
    setSelectedMemberList2(list);
    updateDBSupervisorList(serviceListItem.id, list);
    const updatedSupervisorList = updateManagerSupervisorList(username, supervisorList, serviceListItem.id, list);
    dispatch(setSupervisorList(updatedSupervisorList));
  }

  const updateSelectedMemberList3 = async (list) => {
    sortMemberList(list);
    updateAssignList(serviceListItem.id, list);
    setSelectedMemberList3(list);
    syncSelectedMemberList2(list);
  }

  const CustomComponent = ({ member }) => {
      return getChip(member, handleChipClick);
  };

  const preventRowClickSelection = (e) => {
      // Prevent row selection when clicking on the row
      e.stopPropagation();
  };

//setVisible1
  const onClickVisible1 = (e) => {
      setGlobalFilter('');
      setVisible1(true);
  };

  const onClickVisible2 = (e) => {
      setGlobalFilter('');
      setVisible2(true);
  };

  const onClickVisible3 = (e) => {
      setGlobalFilter('');
      setVisible3(true);
  };

  const cardStyle = {
      // flex: '1',
      margin: '10px 0px',
      // minWidth: '24rem',
      // maxWidth: '24rem',
      // backgroundColor: 'lightBlue',
  };

  useEffect(() => {
    if (memberList.length > 0 && managerList.length > 0) {
      const filteredManagerList = managerList.filter(managerListItem => managerListItem.serviceId === serviceListItem.id);
      const filteredMemberList = memberList.filter(memberListItem => filteredManagerList.some(listItem => listItem.memberId === memberListItem.id));
      setSelectedMemberList1(filteredMemberList); // get full details of each manager in this service
    }    
    if (memberList.length > 0 && supervisorList.length > 0) {
      const filteredSupervisorList = supervisorList.filter(listItem => listItem.serviceId === serviceListItem.id);
      const filteredMemberList = memberList.filter(memberListItem => filteredSupervisorList.some(listItem => listItem.memberId === memberListItem.id));
      setSelectedMemberList2(filteredMemberList); // get full details of each supervisor in this service
    }    
    if (memberList.length > 0 && assignList.length > 0) {
      const filteredAssignList = assignList.filter(assignListItem => assignListItem.serviceId === serviceListItem.id);
      const filteredMemberList = memberList.filter(memberListItem => filteredAssignList.some(assignListItem => assignListItem.memberId === memberListItem.id));
      setSelectedMemberList3(filteredMemberList);
    }    
  }, [serviceListItem]);

  return (

    <div>

        {/* <span className="md:w-25rem lg:w-25rem"> */}

          <Card style={cardStyle} title={serviceListItem && DEBUG ? `${serviceListItem.name} ID${serviceListItem.id} (人數: ${selectedMemberList3.length})` : `${serviceListItem.name} (人數: ${selectedMemberList3.length})`}>

                <div style={{ margin: '5px', padding: '5px' }}>
                  總負責肢體{modify ? <Button size="small" label="修改" text onClick={onClickVisible1}/> : null}
                </div>

                {displayMode === 2 ? 
                  <DataTable 
                    size={'small'}
                    value={selectedMemberList1} 
                  >      
                    {/* <Column field="id" header="ID" ></Column> */}
                    <Column header="姓名" body={(rowData) => <CustomComponent member={rowData}/>}></Column>
                    <Column header="總負責" field='managerServiceIdList.length' body={(rowData) => rowData.managerServiceIdList !== undefined && rowData.managerServiceIdList.length !== 0 ? <span>{rowData.managerServiceIdList.length}</span> : null}></Column>
                    <Column header="服事項" field='assignServiceIdList.length' body={(rowData) => rowData.assignServiceIdList !== undefined && rowData.assignServiceIdList.length !== 0 ? <span>{rowData.assignServiceIdList.length}</span> : null}></Column>
                  </DataTable>
                :
                  <div style={{ margin: '5px', padding: '5px' }}>                  
                    {selectedMemberList1.map((member) => (
                      getChip(member, handleChipClick)
                    ))}                  
                  </div>
                }  

                <div style={{ margin: '5px', padding: '5px' }}>
                  主要負責肢體{modify ? <Button size="small" label="修改" text onClick={onClickVisible2} /> : null}
                </div>

                {displayMode === 2 ? 
                  <DataTable 
                    size={'small'}
                    value={selectedMemberList2} 
                  >      
                    {/* <Column field="id" header="ID" ></Column> */}
                    <Column header="姓名" body={(rowData) => <CustomComponent member={rowData}/>}></Column>
                    <Column header="總負責" field='managerServiceIdList.length' body={(rowData) => rowData.managerServiceIdList !== undefined && rowData.managerServiceIdList.length !== 0 ? <span>{rowData.managerServiceIdList.length}</span> : null}></Column>
                    <Column header="服事項" field='assignServiceIdList.length' body={(rowData) => rowData.assignServiceIdList !== undefined && rowData.assignServiceIdList.length !== 0 ? <span>{rowData.assignServiceIdList.length}</span> : null}></Column>
                  </DataTable>
                :
                  <div style={{ margin: '5px', padding: '5px' }}>                  
                    {selectedMemberList2.map((member) => (
                      getChip(member, handleChipClick)
                    ))}                  
                  </div> 
                }               

                <div style={{ margin: '5px', padding: '5px' }}>
                  服事名單{modify ? <Button size="small" label="修改" text onClick={onClickVisible3} /> : null}
                </div>

                {displayMode === 2 ? 
                  <DataTable 
                    size={'small'}
                    value={selectedMemberList3} 
                  >      
                    {/* <Column field="id" header="ID" ></Column> */}
                    <Column header="姓名" body={(rowData) => <CustomComponent member={rowData}/>}></Column>
                    <Column header="總負責" field='managerServiceIdList.length' body={(rowData) => rowData.managerServiceIdList !== undefined && rowData.managerServiceIdList.length !== 0 ? <span>{rowData.managerServiceIdList.length}</span> : null}></Column>
                    <Column header="服事項" field='assignServiceIdList.length' body={(rowData) => rowData.assignServiceIdList !== undefined && rowData.assignServiceIdList.length !== 0 ? <span>{rowData.assignServiceIdList.length}</span> : null}></Column>
                  </DataTable>
                :
                  selectedMemberList3.map((member) => (
                    getChip(member, handleChipClick)
                  ))
                }

          </Card>

      <Dialog 
        header="總負責名單修改" 
        visible={visible1} 
        style={{ width: '95vw' }} 
        modal 
        onHide={() => setVisible1(false)}
      >

        <span style={{ margin: '5px', padding: '5px' }}>
            <InputText 
                type="search" 
                onInput={(e) => setGlobalFilter(e.target.value)} 
                placeholder="搜尋姓名" 
            />
        </span>

        <DataTable 
          style={{ margin: '5px', padding: '5px' }}
          size={'small'}
          value={memberList} 
          paginator rows={rowsPerPage1} rowsPerPageOptions={[10, 25, 50, 100, 500]} 
          first={first1}
          paginatorTemplate="RowsPerPageDropdown PrevPageLink CurrentPageReport NextPageLink"
          currentPageReportTemplate="{first} to {last} of {totalRecords}"
          selection={selectedMemberList1} 
          onSelectionChange={(e) => updateSelectedMemberList1(e.value)} 
          dataKey="id" 
          onPage={updateRowsPerPage1} // Update rows per page state
          globalFilter={globalFilter}
        >      
          <Column selectionMode="multiple"></Column>        
          <Column field="chineseName" header="姓名" body={(rowData) => <div onClick={preventRowClickSelection}><CustomComponent member={rowData} /></div>} ></Column>
          <Column sortable field='managerServiceIdList.length' header="總負責" body={(rowData) => rowData.managerServiceIdList !== undefined && rowData.managerServiceIdList.length !== 0 ? <span onClick={preventRowClickSelection}>{rowData.managerServiceIdList.length}</span> : null}></Column>
          <Column sortable field='assignServiceIdList.length' header="服事項" body={(rowData) => rowData.assignServiceIdList !== undefined && rowData.assignServiceIdList.length !== 0 ? <span onClick={preventRowClickSelection}>{rowData.assignServiceIdList.length}</span> : null}></Column>
        </DataTable>
      </Dialog>

      <Dialog 
        header="主要負責名單修改" 
        visible={visible2} 
        style={{ width: '95vw' }} 
        modal 
        onHide={() => setVisible2(false)}
      >

        <span style={{ margin: '5px', padding: '5px' }}>
            <InputText 
                type="search" 
                onInput={(e) => setGlobalFilter(e.target.value)} 
                placeholder="搜尋姓名" 
            />
        </span>

        <DataTable 
          style={{ margin: '5px', padding: '5px' }}
          size={'small'}
          value={selectedMemberList3} 
          paginator rows={rowsPerPage2} rowsPerPageOptions={[10, 25, 50, 100, 500]} 
          first={first2}
          paginatorTemplate="RowsPerPageDropdown PrevPageLink CurrentPageReport NextPageLink"
          currentPageReportTemplate="{first} to {last} of {totalRecords}"
          selection={selectedMemberList2} 
          onSelectionChange={(e) => updateSelectedMemberList2(e.value)} 
          dataKey="id" 
          onPage={updateRowsPerPage2} // Update rows per page state
          globalFilter={globalFilter}
        >      
          <Column selectionMode="multiple"></Column>        
          <Column field="chineseName" header="姓名" body={(rowData) => <div onClick={preventRowClickSelection}><CustomComponent member={rowData} /></div>} ></Column>
          <Column sortable field='managerServiceIdList.length' header="總負責" body={(rowData) => rowData.managerServiceIdList !== undefined && rowData.managerServiceIdList.length !== 0 ? <span onClick={preventRowClickSelection}>{rowData.managerServiceIdList.length}</span> : null}></Column>
          <Column sortable field='assignServiceIdList.length' header="服事項" body={(rowData) => rowData.assignServiceIdList !== undefined && rowData.assignServiceIdList.length !== 0 ? <span onClick={preventRowClickSelection}>{rowData.assignServiceIdList.length}</span> : null}></Column>
        </DataTable>
      </Dialog>

      <Dialog 
        header="服事名單修改" 
        visible={visible3} 
        style={{ width: '95vw' }} 
        modal 
        onHide={() => setVisible3(false)}
      >

        <span style={{ margin: '5px', padding: '5px' }}>
            <InputText 
                type="search" 
                onInput={(e) => setGlobalFilter(e.target.value)} 
                placeholder="搜尋姓名" 
            />
        </span>

        <DataTable 
          style={{ margin: '5px', padding: '5px' }}
          size={'small'}
          value={memberList} 
          paginator rows={rowsPerPage3} rowsPerPageOptions={[10, 25, 50, 100, 500]} 
          first={first3}
          paginatorTemplate="RowsPerPageDropdown PrevPageLink CurrentPageReport NextPageLink"
          currentPageReportTemplate="{first} to {last} of {totalRecords}"
          selection={selectedMemberList3} 
          onSelectionChange={(e) => updateSelectedMemberList3(e.value)} 
          dataKey="id" 
          onPage={updateRowsPerPage3} // Update rows per page state
          globalFilter={globalFilter}
        >      
          <Column selectionMode="multiple"></Column>        
          <Column field="chineseName" header="姓名" body={(rowData) => <div onClick={preventRowClickSelection}><CustomComponent member={rowData} /></div>} ></Column>
          <Column sortable field='managerServiceIdList.length' header="總負責" body={(rowData) => rowData.managerServiceIdList !== undefined && rowData.managerServiceIdList.length !== 0 ? <span onClick={preventRowClickSelection}>{rowData.managerServiceIdList.length}</span> : null}></Column>
          <Column sortable field='assignServiceIdList.length' header="服事項" body={(rowData) => rowData.assignServiceIdList !== undefined && rowData.assignServiceIdList.length !== 0 ? <span onClick={preventRowClickSelection}>{rowData.assignServiceIdList.length}</span> : null}></Column>
        </DataTable>
      </Dialog>

      <Dialog 
        header={header}
        visible={visible4} 
        style={{ width: '85vw' }} 
        modal 
        onHide={() => setVisible4(false)}
      >        
        <div style={{ margin: '5px', padding: '5px' }}>
          總負責 (總數: {managerServiceNames && managerServiceNames.length})
        </div>
        <div style={{ margin: '5px', padding: '5px' }}>                 
          {managerServiceNames && 
            managerServiceNames.map((managerServiceName) => (
              <Chip label={managerServiceName} style={{ margin: '5px', backgroundColor: 'lightGreen' }}/>
            ))
          }
        </div>        
        <div style={{ margin: '5px', padding: '5px' }}>
          服事項 (總數: {serviceNames && serviceNames.length})
        </div>
        <div style={{ margin: '5px', padding: '5px' }}>                 
          {serviceNames && 
            serviceNames.map((serviceName) => (
              <Chip label={serviceName} style={{ margin: '5px', backgroundColor: 'lightBlue' }}/>
            ))
          }
        </div>
      </Dialog>

    </div>

  )

}